<module-container>
  <div class="title-container">
    <h2>Invoice Rule Maps</h2>
  </div>
  <abcis-table [configuration]="tableConfig"></abcis-table>
</module-container>
